import { learningObjectivesIntro, activitiesListIntro, standardActivities, standardActivitiesClosing, closing } from './AL00000Sprint00'
import { getModuleDescriptionByClassSectionID } from '../DataAndAPIs/ClassSections'
import { chapter15Lecture, chapter16Lecture, chapter17Lecture } from '../ActivityVideo/ActivityArchitecture'
import { oreillyPlaylistSA } from '../DataAndAPIs/Links'
import { architectureDesignLewisLink } from '../Activities/ArchitectureDesignLewis'
import { initialPost } from './AL00000Sprint00'
import { lionsTigersAndBearsLink } from '../Activities/LionsTigerAndBears'

export const al61200Sprint04 = (classSectionID, sprint) => {
	return ( <div>
		<h5>Sprint {sprint}: {getModuleDescriptionByClassSectionID(classSectionID, sprint-1)}</h5>
		<p><em>Welcome to sprint {sprint}.</em> Designing software architecture is not simply a matter of drawing boxes 
		and lines; it involves making a series of high-impact decisions that shape the system’s structure, behavior, and 
		ability to evolve. A critical step in this process is identifying and addressing Architecturally Significant 
		Requirements (ASRs)—the subset of functional or non-functional requirements that have a measurable impact on the 
		architecture.</p>
		
		<p>In this module, students will explore how to identify ASRs from stakeholder needs, understand their role in 
		guiding architectural choices, and learn structured techniques for designing a software architecture that meets 
		these requirements. Students will apply architectural design practices such as decomposition, interface 
		specification, and pattern selection in the context of ASRs.</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>

			<li>Define Architecturally Significant Requirements (ASRs) and explain their role in the architecture design process.</li>
			<li>Differentiate between functional requirements, quality attributes, and ASRs.</li>
			<li>Identify ASRs from a given set of project requirements and stakeholder concerns.</li>
			<li>Evaluate how ASRs influence architectural decisions such as module structure, data flow, and deployment strategies.</li>
			<li>Apply techniques for designing software architecture that balances quality attributes like performance, modifiability, security, and scalability.</li>
		</ul>

		{list61200Sprint04(sprint)}
		{closing(sprint)}
	</div> )
}

export const list61200Sprint04 = (sprint) => {
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, architectureDesignLewisLink())}
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 15” and watch the associated {chapter15Lecture()}</li>
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 16” and watch the associated {chapter16Lecture()}</li>
			{initialPost(sprint)}
			<li>Review and complete {lionsTigersAndBearsLink()} as an Azure hosted React application</li>
			<li>Within {oreillyPlaylistSA()} read “Software Architecture in Practice - Chapter 17” and watch the associated {chapter17Lecture()}</li>
			{standardActivitiesClosing(sprint, architectureDesignLewisLink(), '8 hours')}
		</ol>
	</div> )
}


/*

		<p>In this sprint, we will focus on the practical aspects of implementing web applications using the MERNa stack 
		
		
		
		
		So we want to build sophisticated meaningful web applications architectures using 
		our newly obtained knowledge of HTML, CSS, JavaScript, Node.js, and React. To do that we need Web servers and Authentication
		and databases. We have this picked out in the form of Node.js, Express, and MongoDB. Great. However, every meaningful web 
		application also needs to be able to Authenticate and Authorize uses in order to be able to effectively leverage web 
		server and database capabilities. It turns out that methods for Authentication vary dramatically and that 
		Authorization is even more none standard. Let’s use this sprint to attempt to standardize this for our ourself
		and for users of the MERNa framework. Should the framework actually be called MERNaaa... MongoDB (M), Express (E),
		React (R), Node.js (N), Azure (a), Authentication (a), and Authorization (a)?</p>

		{learningObjectivesIntro(sprint)}
		<ul style={{listStyleType:'square'}}>
			<li>Deliver HTML, CSS, and JavaScript web applications using Node.js and Express on Microsoft Azure</li>
			<li>Understand the concepts of Authentication and Authorization at both the user and API level</li>
			<li>Add Authentication to a HTML, CSS, JavaScript application running on Node.js and Azure</li>
			<li>Implement a public and secure API using Azure and Node.js using user level Authentication</li>
			<li>Call a Node.js and Azure public and secure API from a React application running on an Azure static website</li>
		</ul>

		{list44500Sprint04(sprint)}
		{closing(sprint)}
	</div> )
}

export const list44500Sprint04 = (sprint) => {
	const reactMax = () => { return externalLink('React - The Complete Guide” ', 'https://learning.oreilly.com/videos/react-the/9781789132229/')}
	const azureStaticReactWithPortal = () => { return externalLink('Quickstart: Azure Static site with React and using Azure portal', 'https://learn.microsoft.com/en-us/azure/static-web-apps/getting-started')}
	return ( <div>
		{activitiesListIntro(sprint)}
		<ol>
			{standardActivities(sprint, reactTicTacToeLeaderBoardLink())} 
			<li>As needed review {HTMLW3C()}, {CSSW3C()}, and {JavaScriptW3C()} all from W3C</li>
			<li>Within {oreillyPlaylistAF()} read “Web Development with Node and Express” chapters 1 through 4</li>
			{initialPost(sprint)}
			<li>Review adding “standard” Azure React Authentication {azureStaticReactWithPortal()}</li>
			<li>Within O’Reilly Books Complete {reactMax()} by Maximilian Schwarzmüller</li>
			{standardActivitiesClosing(sprint, reactTicTacToeLeaderBoardLink(), '8 hours')}
		</ol>
	</div> )
}
	*/